import * as Types from "../../actions/actionTypes";

const initialState = {
  loading: false,
  data: [],
  errors: {},
};

const reviewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.DATA_IDENTIFIERS_LOADING: {
      return {
        ...state,
        loading: true,
        data: [],
        errors: {},
      };
    }
    case Types.DATA_IDENTIFIERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload,
        errors: {},
      };
    }
    case Types.DATA_IDENTIFIERS_FAILURE: {
      return {
        ...state,
        loading: false,
        data: [],
        errors: action.payload,
      };
    }
    default:
      return state;
  }
};

export default reviewsReducer;
